import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Table, TableProps } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import { path, useTableSearchParams } from 'src/libs'
import { ErrorScreen } from 'src/shared/components/errorScreen/errorScreen'
import { setClientAttachmentHistoryRequestError } from './model'
import { useClientAttachmentHistoryWidget } from './hooks'
import { ClientAttachmentHistory, Manager, Partner } from './types'

export const ClientAttachmentHistoryWidget = () => {
  return (
    <CCard>
      <CCardHeader>
        <strong>Attachment history</strong>
      </CCardHeader>
      <CCardBody>
        <div className="mb-1">History of attachment to partner</div>
        <ClientAttachmentHistoryList />
      </CCardBody>
    </CCard>
  )
}

const ClientAttachmentHistoryList = () => {
  return <ClientAttachmentHistoryTable />
}

const ClientAttachmentHistoryTable = () => {
  const [searchParams] = useSearchParams()
  const {
    clientAttachmentHistory,
    loading,
    totalCountOfClientAttachmentHistory,
    onChangeClientAttachmentHistoryList,
    errorClientAttachmentHistoryRequest,
  } = useClientAttachmentHistoryWidget()

  const handleTableChange: TableProps<ClientAttachmentHistory>['onChange'] =
    useTableSearchParams({ usePagination: true })

  useEffect(() => {
    onChangeClientAttachmentHistoryList({
      limit: Number(searchParams.get('limit')) || 10,
      page: Number(searchParams.get('page')) || 1,
    })
  }, [searchParams])

  const columns: ColumnsType<ClientAttachmentHistory> = [
    {
      title: 'Date',
      dataIndex: 'humanCreatedAt',
    },
    {
      title: 'Partner',
      dataIndex: 'partner',
      render: (item: Partner) => (
        <>
          <a href={path.clients.details(item.clientId)} target="_blank">
            {item.fullName}
          </a>
        </>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
    },
    {
      title: 'Manager',
      dataIndex: 'createdBy',
      render: (item: Manager) => {
        return item ? item.fullname : ''
      },
    },
  ]

  if (![0, 404].includes(errorClientAttachmentHistoryRequest.code)) {
    return (
      <ErrorScreen
        showRetry
        onRetry={() => {
          onChangeClientAttachmentHistoryList({
            limit: Number(searchParams.get('limit')) || 10,
            page: Number(searchParams.get('page')) || 1,
          })
          setClientAttachmentHistoryRequestError({
            message: '',
            code: 0,
          })
        }}
      />
    )
  }
  const current = Number(searchParams.get('page')) || 1
  const pageSize = Number(searchParams.get('limit')) || 10
  return (
    <Table
      dataSource={clientAttachmentHistory}
      bordered={true}
      scroll={{ x: true }}
      loading={loading}
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {},
        }
      }}
      rowKey="id"
      columns={columns}
      pagination={{
        current,
        pageSize,
        showSizeChanger: true,
        total: totalCountOfClientAttachmentHistory,
      }}
      onChange={handleTableChange}
    />
  )
}
